import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-admin-optional-subject-popup',
  templateUrl: './admin-optional-subject-popup.component.html',
  styleUrls: ['./admin-optional-subject-popup.component.scss']
})
export class AdminOptionalSubjectPopupComponent implements OnInit {
  subjectForm: FormGroup;
  dialogRef: MatDialogRef<AdminOptionalSubjectPopupComponent>;

  sessionList: any[] = [];
  facultyList: any[] = [];
  courseList: any[] = [];
  courseStreamList: any[] = [];
  examList: any[] = [];
  collegeList: any[] = [];

  filteredSessionList: any[] = [];
  filteredFacultyList: any[] = [];
  filteredCourseList: any[] = [];
  filteredStreamList: any[] = [];
  filteredExamList: any[] = [];
  filteredCollegeList: any[] = [];

  OptSub = false;
  GroupData: any[] = [];
  optData: any[] = [];
  selectedOptions: any[] = [];
  selectedCheckboxes: any[] = [];
  validationErrors: any = {};
  disableButton = true;
  submitButton = true;
  updateButton = false;

  BranchId = 0;
  private savedOptionalEsIds: number[] = [];

  selectedStudent: any;
  private savedBranchId: number = null;
  private savedExamId: number = null;
  StrCode: any;

  msgShow = false;
  Message = '';
  msgFail = false;
  Message2 = '';

  private isLoadingGroups = false;
  private lastLoadedExamId: number = null;
  private lastLoadedBranchId: number = null;

  constructor(
    private fb: FormBuilder,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    public dialogRefPopup: MatDialogRef<AdminOptionalSubjectPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedStudent = data.student;
    this.savedBranchId = data.savedBranchId ? Number(data.savedBranchId) : null;
    this.savedExamId = data.savedExamId ? Number(data.savedExamId) : null;
    this.dialogRef = dialogRefPopup;
  }

  ngOnInit(): void {
    this.initForm();
    this.loadAllMasterDataFirst();
  }

  initForm() {
    this.subjectForm = this.fb.group({
      SubSession: new FormControl({ value: '', disabled: true }),
      SubFacId: new FormControl({ value: '', disabled: true }),
      SubCoId: new FormControl({ value: '', disabled: true }),
      SubBrId: new FormControl({ value: '', disabled: true }),
      SubCgId: new FormControl({ value: '', disabled: true }),
      SubEmId: new FormControl(''),
      StuId: new FormControl(this.selectedStudent?.StuId || ''),
      PrnNo: new FormControl(this.selectedStudent?.StuRgNo || '')
    });
  }

  loadAllMasterDataFirst() {
    this.spinner.show();
    forkJoin({
      sessions: this.umsService.getSession({}),
      faculties: this.umsService.getFaculty({}),
      colleges: this.umsService.getCollege({})
    }).subscribe({
      next: (res) => {
        if (res.sessions.status) this.sessionList = res.sessions.data;
        if (res.faculties.status) this.facultyList = res.faculties.data;
        if (res.colleges.status) this.collegeList = res.colleges.data;

        this.filteredSessionList = [...this.sessionList];
        this.filteredFacultyList = [...this.facultyList];
        this.filteredCollegeList = [...this.collegeList];

        if (this.selectedStudent?.StuId) {
          this.fetchStudentAdmissionAndPopulate();
        } else {
          this.spinner.hide();
        }
      },
      error: () => {
        this.spinner.hide();
        this.showMessage('Error loading master data.', 'error');
      }
    });
  }

  fetchStudentAdmissionAndPopulate() {
    this.spinner.show();
    const payload = { StuId: this.selectedStudent.StuId };
    this.umsService.fetchAddmissionDetails(payload).subscribe({
      next: (res) => {
        if (res.status && res.data && res.data.length) {
          const admission = res.data[0];
          this.selectedStudent = { ...this.selectedStudent, ...admission };

          this.umsService.fetchPersonalDetails(payload).subscribe({
            next: (personalRes) => {
              if (personalRes.status && personalRes.data && personalRes.data.length) {
                const personal = personalRes.data[0];
                this.selectedStudent.StuRgNo = personal.StuRgNo;
                this.selectedStudent.FullName = personal.FullName;
              }

              this.loadCoursesAndBranches(admission.StuCoId, admission.StuBrId).then(() => {
                this.subjectForm.patchValue({
                  StuId: this.selectedStudent.StuId,
                  PrnNo: this.selectedStudent.StuRgNo,
                  SubSession: admission.SessionId,
                  SubFacId: admission.StuFacId,
                  SubCoId: admission.StuCoId,
                  SubBrId: admission.StuBrId,
                  SubCgId: admission.StuCgId
                });

                this.savedBranchId = Number(admission.StuBrId);
                this.BranchId = this.savedBranchId;

                if (admission.StuCoId) {
                  this.loadExams(admission.StuCoId);
                }
                this.spinner.hide();
              }).catch(() => {
                this.spinner.hide();
                this.showMessage('Error loading courses/branches.', 'error');
              });
            },
            error: () => {
              this.spinner.hide();
              this.showMessage('Could not fetch student PRN.', 'error');
            }
          });
        } else {
          this.spinner.hide();
          this.showMessage('Could not fetch student admission details.', 'error');
        }
      },
      error: () => {
        this.spinner.hide();
        this.showMessage('Error fetching student admission details.', 'error');
      }
    });
  }

  loadCoursesAndBranches(coCode: string, branchId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      forkJoin({
        courses: this.umsService.fetchCourseType({}),
        branches: this.umsService.fetchCourseBranch({ CoCode: coCode, EmId: 0 })
      }).subscribe({
        next: (res) => {
          if (res.courses.status) {
            this.courseList = res.courses.data;
            this.filteredCourseList = [...this.courseList];
          }
          if (res.branches.status) {
            this.courseStreamList = res.branches.data;
            this.filteredStreamList = [...this.courseStreamList];
          }
          resolve();
        },
        error: (err) => {
          console.error(err);
          reject();
        }
      });
    });
  }

  loadExams(coCode: string) {
    this.spinner.show();
    const payload = { EmCoCode: coCode, EmId: 0 };
    this.umsService.fetchExam(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.examList = res.data;
          this.filteredExamList = [...this.examList];
          if (this.examList.length) {
            let examToSelect = this.examList[0];
            if (this.savedExamId) {
              const savedExam = this.examList.find(e => e.EmId === this.savedExamId);
              if (savedExam) examToSelect = savedExam;
            }
            this.subjectForm.patchValue({ SubEmId: examToSelect.EmId }, { emitEvent: false });
            this.validateAndLoadOptionalGroups(examToSelect.EmId, this.BranchId);
          }
        }
      },
      error: () => this.spinner.hide()
    });
  }

validateAndLoadOptionalGroups(emId: number, strId: number) {
  const rawForm = this.subjectForm.getRawValue();
  const payload = {
    SnNo: rawForm.SubSession,
    InCode: 'SubSe',
    CoCode: rawForm.SubCoId,
    CgCode: rawForm.SubCgId,
    EmId: emId
  };

  console.log(' Checking cutoff dates with payload:', payload);

  this.spinner.show();
  this.umsService.CheckValidDate(payload).subscribe({
    next: (res) => {
      this.spinner.hide();
      console.log('Cutoff API response:', res);
      if (res.status) {
        const today = new Date();
        const todayDateString = today.toISOString().split('T')[0];
        const validRecords = res.data.filter(record =>
          record.EmId == emId &&
          record.CoCgCoCode == rawForm.SubCoId &&
          record.CoCgCgCode == rawForm.SubCgId
        );

        console.log(' Valid records for this exam/course/college:', validRecords);

        let canOpen = false;
        for (let record of validRecords) {
          const fromDate = record.FromDate.split('T')[0];
          const toDate = record.ToDate.split('T')[0];
          if (fromDate <= todayDateString && todayDateString <= toDate) {
            canOpen = true;
            break;
          }
        }

        if (validRecords.length === 0) {
          console.warn(' No cutoff records found for this combination.');
          this.msgShow = true;
          this.Message = 'Cutoff dates not set for Optional Subject Selection. Please contact administrator.';
          this.OptSub = false;
          this.GroupData = [];
        } else if (!canOpen) {
          console.warn(' Today is outside the cutoff range.');
          this.msgShow = true;
          this.Message = 'Optional Subject Selection is not open or has been closed for the selected exam.';
          this.OptSub = false;
          this.GroupData = [];
        } else {
          console.log(' Cutoff valid – now checking exam edit control.');
          this.checkExamEditControlStatus(emId, rawForm.SubSession, rawForm.SubCoId).then(isValid => {
            if (isValid) {
              console.log('Exam edit control OK – loading optional groups.');
              this.msgShow = false;
              this.Message = '';
              this.loadOptionalGroups(emId, strId);
            } else {
              console.warn(' Exam edit control blocked selection.');
              this.msgShow = true;
              this.Message = 'Optional subject selection is not available at this time.';
              this.OptSub = false;
              this.GroupData = [];
            }
          });
        }
      } else {
        console.warn('Cutoff API returned status false:', res);
        this.msgShow = true;
        this.Message = 'Cutoff dates not configured for Optional Subject Selection.';
        this.OptSub = false;
        this.GroupData = [];
      }
    },
    error: (err) => {
      this.spinner.hide();
      console.error(' Cutoff API error:', err);
      this.msgShow = true;
      this.Message = 'Error checking cutoff dates: ' + (err.error?.message || 'Unknown error');
      this.OptSub = false;
      this.GroupData = [];
    }
  });
}

private checkExamEditControlStatus(emId: number, sessionId: number, coCode: string): Promise<boolean> {
  return new Promise((resolve) => {
    const schedulePayload = { LoginId: sessionStorage.getItem('userId'), ShSnNo: sessionId };
    this.umsService.getSupExamRecord(schedulePayload).subscribe({
      next: (res) => {
        if (res.status && res.data && res.data.length) {
          const examSchedule = res.data.find((e: any) => e.ShEmId == emId);
          if (examSchedule) {
            const shId = examSchedule.ShId;
            console.log(' Found schedule ShId:', shId);
            const editPayload = { EcShId: shId, EcInCode: 19, EcOpId: sessionStorage.getItem('userId') };
            this.umsService.getSupExamEditRecord(editPayload).subscribe({
              next: (editRes) => {
                if (editRes.status && editRes.data && editRes.data.length > 0) {
                  const hasOpen = editRes.data.some(record => record.EcStatus === 'O');
                  console.log(' Exam Form Edit Control Statuses:', editRes.data.map(r => r.EcStatus));
                  if (hasOpen) {
                    this.showMessage('Exam forms activity is currently open. Optional subject selection is not allowed.', 'error');
                    resolve(false);
                  } else {
                    resolve(true);
                  }
                } else {
                  console.log('No exam form record found – allowing selection.');
                  resolve(true);
                }
              },
              error: () => {
                console.log(' Error fetching exam edit control – allowing selection.');
                resolve(true);
              }
            });
          } else {
            console.log(' No schedule found for this exam – allowing selection.');
            resolve(true);
          }
        } else {
          console.log('No schedules returned from API – allowing selection.');
          resolve(true);
        }
      },
      error: () => {
        console.log(' Error fetching exam schedule – allowing selection.');
        resolve(true);
      }
    });
  });
}

  onExamChange(emId: number) {
    const selectedExam = this.examList.find(e => e.EmId === emId);
    if (selectedExam && this.BranchId) {
      this.validateAndLoadOptionalGroups(selectedExam.EmId, this.BranchId);
    }
  }

  loadOptionalGroups(emId: number, strId: number) {
    if (this.isLoadingGroups) return;
    if (emId === this.lastLoadedExamId && strId === this.lastLoadedBranchId) return;

    this.isLoadingGroups = true;
    this.spinner.show();
    const payload = { EsEmId: emId, EsStrId: strId };
    this.umsService.getExamSubMapFetch(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        this.isLoadingGroups = false;
        if (res.status && res.data.children) {
          this.lastLoadedExamId = emId;
          this.lastLoadedBranchId = strId;
          this.processGroups(res.data.children);
          this.loadOptionRules(emId, strId);
          this.loadSavedSelectionsForStudent();
        } else {
          console.warn('No groups returned for exam', emId, 'branch', strId);
        }
      },
      error: () => {
        this.spinner.hide();
        this.isLoadingGroups = false;
      }
    });
  }

  processGroups(children: any[]) {
    this.GroupData = [];
    this.selectedOptions = [];
    children.forEach(element => {
      if (element.EsType === 'G') {
        this.OptSub = true;
        if (element.EsOpCode && element.EsOpCode !== ' ') {
          if (!this.selectedOptions.includes(element.EsOpCode))
            this.selectedOptions.push(element.EsOpCode);
        }
        this.GroupData.push(element);
        if (element.children) {
          element.children.forEach(child => {
            if (child.EsOpCode && child.EsOpCode !== ' ') {
              if (!this.selectedOptions.includes(child.EsOpCode))
                this.selectedOptions.push(child.EsOpCode);
            }
          });
        }
      }
    });
  }

  loadOptionRules(emId: number, strId: number) {
    const payload = { OpEmId: emId, OpStrId: strId };
    this.umsService.getOption(payload).subscribe({
      next: (res) => {
        if (res.status) {
          this.optData = res.data.filter(opt => this.selectedOptions.includes(opt.OpCode));
          this.validateAllOpCodes();
        }
      }
    });
  }

  loadSavedSelectionsForStudent() {
    if (!this.selectedStudent) return;
    const params = {
      StuId: this.selectedStudent.StuId,
      StrId: this.BranchId,
      EmId: this.subjectForm.value.SubEmId,
      Session: this.subjectForm.getRawValue().SubSession
    };
    this.umsService.getSavedOptionalSubjects(params).subscribe({
      next: (res) => {
        if (res.status && res.data) {
          this.savedOptionalEsIds = res.data.map(item => item.EsId);
          this.applySavedSelections();
          this.updateButton = this.savedOptionalEsIds.length > 0;
          this.submitButton = !this.updateButton;
        } else {
          this.savedOptionalEsIds = [];
          this.submitButton = true;
          this.updateButton = false;
        }
      },
      error: () => {}
    });
  }

  applySavedSelections() {
    const savedSet = new Set(this.savedOptionalEsIds);
    const allItems = this.getAllFlatItems();
    this.selectedCheckboxes = allItems.filter(item => savedSet.has(item.EsId));
    this.validateAllOpCodes();
  }

  getAllFlatItems() {
    const flat: any[] = [];
    this.GroupData.forEach(group => {
      flat.push(group);
      if (group.children) flat.push(...group.children);
    });
    return flat;
  }

  onCheckboxChanged(event: any, item: any) {
    if (event.checked) {
      if (!this.selectedCheckboxes.some(x => x.EsId === item.EsId))
        this.selectedCheckboxes.push(item);
    } else {
      this.selectedCheckboxes = this.selectedCheckboxes.filter(x => x.EsId !== item.EsId);
    }
    this.validateAllOpCodes();
  }

  shouldCheckItemForGroup(item: any): boolean {
    return this.selectedCheckboxes.some(x => x.EsId === item.EsId);
  }

  validateAllOpCodes() {
    this.validationErrors = {};
    this.optData.forEach(rule => {
      const count = this.selectedCheckboxes.filter(i => i.EsOpCode === rule.OpCode).length;
      if (count < rule.OpMin || count > rule.OpMax) {
        this.validationErrors[rule.OpCode] = ` Error : Option ${rule.OpCode}:  Please select min ${rule.OpMin} and max ${rule.OpMax} subjects.`;
      }
    });
    this.disableButton = Object.keys(this.validationErrors).length > 0;
  }

  getValidationErrorsKeys(): string[] {
    return Object.keys(this.validationErrors);
  }

  saveSelection() {
    if (this.disableButton || !this.selectedStudent) return;

    const esIdsList = this.selectedCheckboxes.map(item => item.EsId).join(',');
    const rawForm = this.subjectForm.getRawValue();

    const StuRgNo = this.selectedStudent.StuRgNo;
    if (!StuRgNo) {
      this.showMessage('Student PRN is missing. Please close and reopen the popup.', 'error');
      return;
    }

    const payload = {
      Session: Number(rawForm.SubSession),
      CoCode: rawForm.SubCoId || this.selectedStudent.StuCoId,
      CgCode: rawForm.SubCgId || this.selectedStudent.StuCgId,
      PrnNo: StuRgNo,
      EmId: rawForm.SubEmId,
      StrId: this.BranchId,
      EsIds: esIdsList
    };

    this.spinner.show();
    const request = this.updateButton
      ? this.umsService.updateOptionalSubjectSelectionDetails(payload)
      : this.umsService.insertOptionalSubjectSelectionDetails(payload);

    request.subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.showMessage('Saved successfully', 'success');
          this.loadSavedSelectionsForStudent();
        } else {
          this.showMessage(res.message, 'error');
        }
      },
      error: (err) => this.handleError(err)
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  private showMessage(msg: string, type: 'success' | 'error' | 'info') {
    const data = {
      message: msg,
      title: type === 'success' ? 'Information' : 'Error',
      icon: type === 'success' ? 'fas fa-check' : 'fas fa-close'
    };
    const messageDialogRef = this.modalPopupService.openPopup(AlertBoxComponent, data);
    if (type === 'success') {
      messageDialogRef.afterClosed().subscribe(() => {
        this.loadSavedSelectionsForStudent();
      });
    }
  }

  private handleError(error: HttpErrorResponse) {
    this.spinner.hide();
    this.showMessage(error.error?.message || 'Something went wrong', 'error');
  }
  getOptForCode(opCode: string) {
  return this.optData?.find(opt => opt.OpCode === opCode);
}
}